<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const TONES = [
  { value: 'accent', label: t('site.f.announcement.opt_accent', 'Accent') },
  { value: 'surface', label: t('site.f.announcement.opt_surface', 'Surface') },
  { value: 'outline', label: t('site.f.announcement.opt_outline', 'Outline') }
] as const
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField
    :label="t('site.f.announcement.message', 'Message')"
    :error="!block.data.text ? t('site.f.announcement.err_message', 'This block needs a message before the page can be saved.') : undefined"
  >
    <UInput
      v-model="block.data.text"
      class="w-full"
    />
  </UFormField>
  <div class="grid grid-cols-2 gap-2">
    <UFormField :label="t('site.f.common.link_text_label', 'Link text')">
      <UInput
        :model-value="block.data.link_text ?? ''"
        class="w-full"
        @update:model-value="block.data.link_text = String($event)"
      />
    </UFormField>
    <UFormField :label="t('site.f.common.link_url_label', 'Link URL')">
      <UInput
        :model-value="block.data.link_url ?? ''"
        :placeholder="t('site.f.common.url_placeholder', 'https://...')"
        class="w-full"
        @update:model-value="block.data.link_url = String($event)"
      />
    </UFormField>
  </div>
  <UFormField
    :label="t('site.f.announcement.tone', 'Tone')"
    :help="t('site.f.announcement.this_block_always_spans_the_full_page_wi_help', 'This block always spans the full page width.')"
  >
    <SiteEditorOptionToggle
      :options="TONES"
      :model-value="block.data.tone ?? 'accent'"
      @update:model-value="block.data.tone = $event as 'accent' | 'surface' | 'outline'"
    />
  </UFormField>
  <UFormField
    :label="t('site.f.announcement.let_visitors_dismiss_it', 'Let visitors dismiss it')"
    :help="t('site.f.announcement.reappears_on_the_next_page_load_it_is_no_help', 'Reappears on the next page load — it is not remembered.')"
  >
    <USwitch v-model="block.data.dismissible" />
  </UFormField>
</template>
